module.exports = __webpack_public_path__ + "img/section1_img3.ba664100.png";